import React from 'react';
import { AlertCircle, Info } from 'lucide-react';

export interface NotionBannerProps {
  type: 'error' | 'warning';
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const NotionBanner: React.FC<NotionBannerProps> = ({
  type,
  icon,
  children,
}) => {
  const isError = type === 'error';
  const bgClass = isError ? 'bg-red-50 border-red-200' : 'bg-amber-50 border-amber-200';
  const textClass = isError ? 'text-red-700' : 'text-amber-700';
  const defaultIcon = isError ? (
    <AlertCircle className="h-4 w-4 flex-shrink-0" />
  ) : (
    <Info className="h-4 w-4 flex-shrink-0" />
  );

  return (
    <div className={`flex gap-3 p-3 border rounded-lg ${bgClass} ${textClass} text-sm`}>
      <div className="flex-shrink-0 flex items-start pt-0.5">
        {icon || defaultIcon}
      </div>
      <div className="flex-1">{children}</div>
    </div>
  );
};
